<ui-dialog
    #assignInterview
    size="small"
    header="applicant-tracker.assignInterviews"
    [open]="isAssignModalOpen"
    (closing)="onCancelAssigningInteriewers()"
>
    <p class="margin-top-2">{{ 'applicant-tracker.specifyTheDetailsForTheApplicantsInterview' | translate }}</p>
    <form [class.loading]="isLoading" [formGroup]="formGroup">
        <div class="flex margin-top-4">
            <mat-form-field class="columns-2 large-columns-7 no-labels no-helpers">
                <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.selectAnInterview' | translate }}</mat-label>
                <mat-select formControlName="interviewSelect" name="interviewSelect" data-cy="interviewSelect">
                    <mat-option *ngFor="let interview of interviews" [value]="interview.id">{{
                        interview.name
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <p class="margin-top-4 margin-bottom-1">{{ 'applicant-tracker.selectOneOrMoreInterviewers' | translate }}*</p>
        <mat-divider></mat-divider>

        <ng-container formGroupName="myCheckboxGroup" *ngFor="let interviewer of interviewers">
            <div class="flex align-items-center margin-top-1 margin-bottom-1">
                <mat-checkbox
                    [formControlName]="interviewer.employee.id"
                    [name]="interviewer.employee.id"
                    (change)="interviewer.isSelected = $event.checked"
                ></mat-checkbox>
                <app-avatar class="margin-left-1" [employee]="interviewer.employee" [name]="true"></app-avatar>
            </div>
            <mat-divider></mat-divider>
        </ng-container>
        <div class="app-grid">
            <mat-form-field class="margin-top-3 columns-8">
                <mat-label>{{ 'applicant-tracker.feedbackDueDate' | translate }}</mat-label>
                <input
                    [matDatepicker]="feedbackDueDatePicker"
                    name="feedbackDueDateInput"
                    formControlName="feedbackDueDate"
                    [min]="minDate"
                    data-cy="feedbackDueDate"
                    matInput
                />
                <mat-datepicker-toggle matPrefix [for]="feedbackDueDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #feedbackDueDatePicker></mat-datepicker>
                <mat-datepicker-toggle matSuffix [for]="feedbackDueDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="chevronDown"></mat-icon>
                </mat-datepicker-toggle>
            </mat-form-field>
        </div>
    </form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="onCancelAssigningInteriewers()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave(formGroup)">{{ 'assign' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>
<div [class.loading]="isLoading">
    <app-table
        class="table"
        [table]="applicantInterviewsTable"
        [useStickyHeader]="false"
        [showSearch]="false"
        [showOffset]="false"
        [showPagination]="false"
        title="{{ 'applicant-tracker.interviews' | translate }}"
    >
        <app-empty-state
            src="/assets/illustrations/documents.png"
            label="{{ 'applicant-tracker.messages.interview.viewAndManageAssignedInterviewsFromHere' | translate }}"
        ></app-empty-state>
        <div class="buttons">
            <ui-button
                [disabled]="!interviews.length"
                *ngIf="hasRecruiterAccess"
                class="buttons"
                type="outline"
                (click)="openAssignModal()"
            >
                {{ 'applicant-tracker.assignInterview' | translate }}
            </ui-button>
        </div>
    </app-table>
</div>
